import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchSubscriptionStatus } from "../../store/slices/subscriptionSlice";
import { ExclamationTriangleIcon, LockClosedIcon } from "@heroicons/react/24/outline";

export default function SubscriptionGate({ children }) {
  const dispatch = useDispatch();
  const { status, isInTrial, canSendQuote, quotesUsed, quotesLimit, fetchStatus } =
    useSelector((state) => state.subscription);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchSubscriptionStatus());
    }
  }, [dispatch, fetchStatus]);

  if (fetchStatus === "loading") return children;

  const hasAccess = status?.subscription?.active || isInTrial;

  if (!hasAccess) {
    return (
      <div className="max-w-lg mx-auto mt-12 text-center">
        <LockClosedIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Subscription Required</h2>
        <p className="text-gray-500 mb-6">
          You need an active subscription to access this feature. Start with a 14-day free trial.
        </p>
        <Link
          to="/settings"
          className="inline-flex px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700"
        >
          View Plans
        </Link>
      </div>
    );
  }

  return (
    <>
      {/* Trial warning banner */}
      {isInTrial && status?.trialEndsAt && (
        <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ExclamationTriangleIcon className="h-5 w-5 text-amber-500" />
            <span className="text-sm text-amber-700">
              Free trial ends {new Date(status.trialEndsAt).toLocaleDateString()}.
            </span>
          </div>
          <Link to="/settings" className="text-sm text-amber-700 font-medium hover:underline">
            Subscribe now
          </Link>
        </div>
      )}

      {/* Quota warning */}
      {canSendQuote && quotesLimit > 0 && quotesUsed >= quotesLimit * 0.8 && (
        <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-lg flex items-center gap-2">
          <ExclamationTriangleIcon className="h-5 w-5 text-orange-500" />
          <span className="text-sm text-orange-700">
            {quotesUsed}/{quotesLimit} quotes used this month.{" "}
            {quotesUsed >= quotesLimit
              ? "Upgrade to send more."
              : "Running low."}
          </span>
        </div>
      )}

      {children}
    </>
  );
}
